/**
 * THE CABINET'S PROVIDERS: web/ui's (theme, colour scheme, notifications) speaking the cabinet's
 * language (design 29, W5). The shared components take their words from the `ui` catalogue, and the
 * date pickers' month and day names follow the language chosen; both redraw when it changes. The
 * admin console mounts `AppProviders` bare and stays English.
 */
import { AppProviders } from '@moonx/ui';
import type { UiTranslate } from '@moonx/ui';
import { useCallback } from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from '../../i18n';

export function CabinetProviders({ children }: { readonly children: ReactNode }) {
  const { t, i18n } = useTranslation('ui');
  // A new function per language: `t` is fixed to it, so the components below redraw.
  const translate = useCallback<UiTranslate>((key, values) => t(key, values ?? {}), [t]);
  return (
    <AppProviders language={i18n.language} translate={translate}>
      {children}
    </AppProviders>
  );
}
